const { Component } = Shopware;
const { Criteria } = Shopware.Data;
const utils = Shopware.Utils;

Component.extend('acris-blog-create', 'acris-blog-detail', {

    inject: [
        'context'
    ],

    beforeRouteEnter(to, from, next) {
        if (to.name.includes('acris.blog.create') && !to.params.id) {
            to.params.id = utils.createId();
        }

        next();
    },

    methods: {
        createdComponent() {
            if (!Shopware.Store.get('context').isSystemDefaultLanguage) {
                Shopware.Store.get('context').resetLanguageToDefault();
            }

            this.item = this.blogRepository.create(Shopware.Context.api, this.$route.params.id);

            this.item.active = true;
            this.item.publicationDate = (new Date()).toISOString();
            this.item.contentType = 'layout';

            this.item.internalName = '';
            this.item.title = '';
            this.additionalMediaCollection = this.item.additionalMedia;
            this.item.cmsPageId = null;
            this.onLayoutSelect(this.item.cmsPageId);

            const criteria = new Criteria(1, 1);
            criteria.addFilter(Criteria.equals('active', true));

            this.blogGroupRepository.search(criteria, Shopware.Context.api).then((result) => {
                if (result.total === 1) {
                    const singleGroup = result.first();
                    // Build a proper EntityCollection for the many-to-many association
                    const collection = new Shopware.Data.EntityCollection(
                        '/acris_blog_group',
                        'acris_blog_group',
                        Shopware.Context.api,
                        new Criteria(1, 25)
                    );
                    collection.add(singleGroup);
                    this.item.blogGroups = collection;
                }
            });

            this.isLoading = false;
        },

        saveFinish() {
            this.isSaveSuccessful = false;
            this.$router.push({ name: 'acris.blog.detail', params: { id: this.item.id } });
        },

        onSave() {
            this.$super('onSave');
        },

    }
});
